import { FormikHelpers } from "formik";
import OtellConTypeForm from "./OtellConTypeForm";
import { useGetOtellConType } from "./api/getOtellConType";
import { useEditOtellConType } from "./api/editOtellConType";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditOtellConType = ({handleCloseModal, otellConTypeId}: EditOtellConTypeProps)  => {
  const getOtellConTypeQuery = useGetOtellConType({otellConTypeId: otellConTypeId})
  const editOtellConTypeMutation = useEditOtellConType({data: {}, otellConTypeId});

  const handleSubmit = async (values: IPostEditOtellConType, { setSubmitting }: FormikHelpers<IPostEditOtellConType>): Promise<void> => {
    try {
      await editOtellConTypeMutation.mutateAsync({
        data: values,
        otellConTypeId: otellConTypeId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
      setSubmitting(false);
    }
  }

  if (getOtellConTypeQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getOtellConTypeQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Είδους τηλεπ. γραμμής ΟΤΕ</div>
    )
  }

  return (
    <>
      {!getOtellConTypeQuery.isLoading && getOtellConTypeQuery.data &&
        <OtellConTypeForm initialValues={getOtellConTypeQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditOtellConTypeProps {
  otellConTypeId: number;
  handleCloseModal: () => void;
}

export default EditOtellConType;